function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M135 270C209.558 270 270 209.558 270 135C270 60.4416 209.558 0 135 0C60.4416 0 0 60.4416 0 135C0 209.558 60.4416 270 135 270Z",
  fill: "#189D48",
  fillOpacity: 0.26
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M183.276 181.966C182.111 181.97 181.022 181.385 180.382 180.411C179.742 179.437 179.637 178.206 180.103 177.138L200.517 130.828V89.7586C200.517 87.8542 202.061 86.3103 203.966 86.3103C205.87 86.3103 207.414 87.8542 207.414 89.7586C207.414 135.207 207.414 131.966 207.138 132.931L186.448 179.828C185.919 181.115 184.668 181.959 183.276 181.966Z",
  fill: "#9FC9D3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M224.655 181.966C223.28 181.97 222.033 181.157 221.483 179.897L200.793 132.931C200.379 132 200.517 135.586 200.517 89.7586C200.517 87.8542 202.061 86.3103 203.966 86.3103C205.87 86.3103 207.414 87.8542 207.414 89.7586V130.828L227.828 177.138C228.294 178.206 228.189 179.437 227.549 180.411C226.909 181.385 225.82 181.97 224.655 181.966Z",
  fill: "#9FC9D3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.8622 151C47.4411 149.643 44.9987 146.57 44.4484 142.931L36.3449 88.8276C35.5723 83.69 38.73 78.7764 43.7242 77.3448L67.8622 69.4828L66.0346 156.069C60.7756 155.056 55.6738 153.352 50.8622 151Z",
  fill: "#2C3E50"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M88.4483 235C114.158 235 135 214.158 135 188.448C135 162.738 114.158 141.897 88.4483 141.897C62.7385 141.897 41.8966 162.738 41.8966 188.448C41.8966 214.158 62.7385 235 88.4483 235Z",
  fill: "#95A5A5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M131.552 170.862C131.552 179.448 131.966 182 130.345 185.241C128.98 188.128 126.518 190.35 123.507 191.412C120.495 192.474 117.184 192.289 114.31 190.897C110.124 188.892 107.447 184.676 107.414 180.035V186.724C107.493 192.517 103.511 197.577 97.8622 198.862C94.2759 199.641 90.5303 198.74 87.6897 196.417C84.8492 194.093 83.224 190.601 83.276 186.931V164.552C83.3233 162.929 82.2318 161.492 80.6553 161.103C62.9656 156.724 64.6553 157.172 63.9311 156.897C61.6914 156.135 59.7249 154.732 58.276 152.862C69.6703 143.206 85.0034 139.599 99.5075 143.162C114.012 146.725 125.928 157.026 131.552 170.862Z",
  fill: "#7F8C8D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M79.8277 221.207C85.541 221.207 90.1725 216.575 90.1725 210.862C90.1725 205.149 85.541 200.517 79.8277 200.517C74.1144 200.517 69.4829 205.149 69.4829 210.862C69.4829 216.575 74.1144 221.207 79.8277 221.207Z",
  fill: "#7F8C8D"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M131.552 140.172C131.552 176.828 132 176.379 130.345 179.828C128.987 182.721 126.527 184.95 123.515 186.019C120.503 187.088 117.188 186.907 114.31 185.517C110.124 183.513 107.447 179.297 107.414 174.655V181.207C107.493 187 103.511 192.06 97.8621 193.345C94.2996 194.118 90.5787 193.234 87.744 190.942C84.9092 188.65 83.2661 185.197 83.2759 181.552V159.138C83.3232 157.515 82.2317 156.079 80.6552 155.69C63.1724 151.483 64.6552 151.897 63.931 151.621C59.0285 149.926 55.7264 145.325 55.6897 140.138V102.448L110.103 98.5862L128.483 132.138C130.463 134.345 131.557 137.207 131.552 140.172Z",
  fill: "#35495E"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M114.31 141.897V185.517C110.101 183.539 107.413 179.306 107.414 174.655C107.414 138.345 107.862 140.172 106.138 137.379C105.257 136.33 105.081 134.859 105.689 133.632C106.297 132.404 107.574 131.653 108.942 131.718C110.311 131.783 111.511 132.651 112 133.931C113.482 136.326 114.281 139.08 114.31 141.897Z",
  fill: "#2C3E50"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M103.966 108.276C112.172 126.379 104.931 128.966 108.241 136.103C112.552 145.552 134.172 146.448 128 114.724C126.862 108.793 124.793 100.276 120 96.1724L103.966 108.276Z",
  fill: "#3F5C6C"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M107.414 159.138C114.069 151.655 123.724 141.103 130.379 135C148.483 118.241 179.207 94.7241 215.793 86.7241C219.316 85.737 221.455 82.1709 220.667 78.5982C219.879 75.0256 216.439 72.6898 212.828 73.2759C181.207 80.1724 143.862 99.9655 108.793 137.034C108.305 137.478 107.845 137.95 107.414 138.448V159.138Z",
  fill: "#A56A43"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M203.966 228.103C221.105 228.103 235 214.209 235 197.069C235 179.929 221.105 166.034 203.966 166.034C186.826 166.034 172.931 179.929 172.931 197.069C172.931 214.209 186.826 228.103 203.966 228.103Z",
  fill: "#95A5A5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M191.897 207C196.658 207 200.517 203.14 200.517 198.379C200.517 193.618 196.658 189.759 191.897 189.759C187.135 189.759 183.276 193.618 183.276 198.379C183.276 203.14 187.135 207 191.897 207Z",
  fill: "#7F8C8D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M155.69 76.3793C153.785 76.3793 152.241 74.8355 152.241 72.931V59.1379C152.241 57.2335 153.785 55.6897 155.69 55.6897C157.594 55.6897 159.138 57.2335 159.138 59.1379V72.931C159.138 74.8355 157.594 76.3793 155.69 76.3793Z",
  fill: "#1ED760"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M162.586 69.4828H148.793C146.889 69.4828 145.345 67.9389 145.345 66.0345C145.345 64.13 146.889 62.5862 148.793 62.5862H162.586C164.491 62.5862 166.035 64.13 166.035 66.0345C166.035 67.9389 164.491 69.4828 162.586 69.4828Z",
  fill: "#1ED760"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M176.379 148.793C174.475 148.793 172.931 147.249 172.931 145.345V131.552C172.931 129.647 174.475 128.103 176.379 128.103C178.284 128.103 179.828 129.647 179.828 131.552V145.345C179.828 147.249 178.284 148.793 176.379 148.793Z",
  fill: "#1ED760"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M183.276 141.897H169.483C167.578 141.897 166.035 140.353 166.035 138.448C166.035 136.544 167.578 135 169.483 135H183.276C185.18 135 186.724 136.544 186.724 138.448C186.724 140.353 185.18 141.897 183.276 141.897Z",
  fill: "#1ED760"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M217.759 55.6897C215.854 55.6897 214.31 54.1458 214.31 52.2414V38.4483C214.31 36.5438 215.854 35 217.759 35C219.663 35 221.207 36.5438 221.207 38.4483V52.2414C221.207 54.1458 219.663 55.6897 217.759 55.6897Z",
  fill: "#1ED760"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M224.655 48.7931H210.862C208.958 48.7931 207.414 47.2493 207.414 45.3448C207.414 43.4404 208.958 41.8966 210.862 41.8966H224.655C226.56 41.8966 228.103 43.4404 228.103 45.3448C228.103 47.2493 226.56 48.7931 224.655 48.7931Z",
  fill: "#1ED760"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M128.379 212.414C123.493 220.478 116.28 226.873 107.69 230.759C102.624 225.045 103.149 216.307 108.862 211.241C114.575 206.176 123.314 206.701 128.379 212.414Z",
  fill: "#7F8C8D"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M66.0345 181.552C66.0278 187.178 62.9758 192.361 58.0581 195.095C53.1405 197.829 47.128 197.688 42.3448 194.724C40.976 184.958 42.7769 175.011 47.4828 166.345C52.0385 165.436 56.7616 166.617 60.3543 169.562C63.947 172.507 66.0313 176.906 66.0345 181.552Z",
  fill: "#7F8C8D"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M57.207 91.6552C55.8622 93.8966 55.8967 94.8966 54.8967 101C52.6544 114.437 59.4376 127.766 71.6208 133.862C94.0346 145.034 93.8622 145.345 97.0691 145.345C100.806 145.342 104.251 143.323 106.081 140.064C107.91 136.805 107.84 132.813 105.897 129.621C103.828 126.172 101.241 125.552 92.6898 121.241L80.8967 115.345C77.942 113.874 75.8667 111.081 75.3105 107.828L57.207 91.6552Z",
  fill: "#3F5C6C"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2415 72.931C52.2415 93.8798 69.2238 110.862 90.1725 110.862C111.121 110.862 128.103 93.8798 128.103 72.931C128.103 51.9823 111.121 35 90.1725 35C69.2238 35 52.2415 51.9823 52.2415 72.931Z",
  fill: "#547580"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M123.31 91.3793C109.103 100.276 87.6898 98.5172 76.3794 87.7586C59.6898 72 74.9311 48.7931 102.241 48.7931C109.658 48.6873 116.956 50.6581 123.31 54.4828C129.695 65.953 129.695 79.9091 123.31 91.3793Z",
  fill: "#1ED760"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M117.759 76.3793C115.854 76.3793 114.31 74.8355 114.31 72.931C114.31 62.5862 101.069 62.5862 100.517 62.5862C98.6129 62.5862 97.0691 61.0424 97.0691 59.1379C97.0691 57.2335 98.6129 55.6897 100.517 55.6897C107.69 55.6897 121.207 59.3103 121.207 72.931C121.207 74.8355 119.663 76.3793 117.759 76.3793Z",
  fill: "#F9EAB0"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M126.69 83.2759C125.871 86.1281 124.713 88.8718 123.241 91.4483C113.097 97.3509 100.952 98.7627 89.7241 95.3448C72.1724 90.0345 64.6897 75 72.4828 62.8621C83.4483 75.6552 101.034 87.7931 126.69 83.2759Z",
  fill: "#1DB954"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M234.724 201.034C233.521 210.325 228.186 218.575 220.207 223.483C214.751 221.646 211.01 216.614 210.822 210.861C210.634 205.107 214.039 199.842 219.363 197.654C224.687 195.465 230.811 196.813 234.724 201.034Z",
  fill: "#7F8C8D"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M217.759 170.793C217.249 176.013 212.64 179.854 207.414 179.414C199.552 179.414 194.517 172.517 198.414 166.517C204.924 165.336 211.642 166.266 217.586 169.172C217.686 169.707 217.744 170.249 217.759 170.793Z",
  fill: "#7F8C8D"
});

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.e157b3fb.svg";
export { ForwardRef as ReactComponent };